import React, { useCallback } from 'react';
import {
  AdaptiveFilter,
  Box,
  CalendarPickerIcon,
  DateRangeDropdown,
  OptionKey,
  useResponsive,
} from '@common-fe/common-fe';

import { useMoneyTransferOptions } from '../hooks';

import MoneyTransfersStatusSelect from './MoneyTransfersStatusSelect';

interface Props {
  currentStatuses: OptionKey[];
  onSetCurrentStatuses: (values: OptionKey[]) => void;

  dateRange: Array<Date | null>;
  onSetDateRange: (value: Array<Date | null>) => void;
}
const TransactionsHistoryFilters: React.FC<Props> = ({
  dateRange,
  onSetDateRange,
  currentStatuses,
  onSetCurrentStatuses,
}) => {
  const options = useMoneyTransferOptions();
  const { isMobile } = useResponsive();

  const {
    isFilterVisible,
    setIsFilterVisible,
    handleCancelFilter,
    handleSubmitFilter,
    isFilterApplied,
    handleResetFilter,
    filters,
    setFilter,
  } = AdaptiveFilter.useAdaptiveFilter<{
    currentStatuses: OptionKey[];
    dateRange: Array<Date | null>;
  }>({
    initialFilters: {
      currentStatuses: currentStatuses || [],
      dateRange: dateRange || [null, null],
    },
    onSubmit: (appliedFilters) => {
      onSetDateRange(appliedFilters.dateRange);
      onSetCurrentStatuses(appliedFilters.currentStatuses);
    },
  });
  const handleClear = useCallback(() => {
    setIsFilterVisible(false);
    handleResetFilter();
    onSetDateRange([null, null]);
    onSetCurrentStatuses([]);
  }, [handleResetFilter, onSetCurrentStatuses, onSetDateRange, setIsFilterVisible]);
  if (isMobile) {
    return (
      <AdaptiveFilter
        isFilterApplied={isFilterApplied}
        testId="test-filter"
        title="Title"
        onClear={handleClear}
        isVisible={isFilterVisible}
        onSetIsVisible={setIsFilterVisible}
        footer={
          <AdaptiveFilter.Footer
            testId="footer"
            onCancel={handleCancelFilter}
            onSubmit={handleSubmitFilter}
          />
        }
      >
        <AdaptiveFilter.ChipsToggler
          testId="funds"
          label="Funds"
          options={options}
          values={filters.currentStatuses}
          onChangeValues={(value) => setFilter('currentStatuses', value)}
        />

        <AdaptiveFilter.DateRange
          testId="period"
          isDateRangeMode
          label="Period"
          value={filters.dateRange as [Date | null, Date | null]}
          onChangeValue={(value) => setFilter('dateRange', value)}
        />
      </AdaptiveFilter>
    );
  }
  return (
    <Box direction="row">
      <Box width="180px">
        <MoneyTransfersStatusSelect
          options={options}
          values={currentStatuses}
          onChangeValues={onSetCurrentStatuses}
        />
      </Box>
      <Box width="180px" margin={{ left: 's' }}>
        <DateRangeDropdown
          testId="money-transfer_range"
          prefix="Period:"
          onChange={(range) => {
            onSetDateRange(range);
          }}
          ellipsisMode
          startDate={dateRange[0]}
          endDate={dateRange[1]}
          icon={
            <Box>
              <CalendarPickerIcon color="iconPrimary" />
            </Box>
          }
        />
      </Box>
    </Box>
  );
};
export default TransactionsHistoryFilters;
